import { Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { SettingCard } from '@/entities/setting/SettingCard'
import { SettingHistory } from '@/entities/setting/SettingHistory'
import { useSetting, useSettingHistory } from '@/shared/api/system-settings'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { ToolbarWrapper } from '@/shared/ui/toolbar-wrapper'
import { WidgetWrapper } from '@/shared/ui/widget-wrapper'

export const Route = createFileRoute('/_auth/administration/settings/$settingId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { isOpen, close } = useRouteOffcanvas()
  const { settingId } = Route.useParams()

  const { data: setting, isLoading, isError } = useSetting({ id: settingId, enabled: true })
  const {
    data: historyData,
    isLoading: historyLoading,
    isError: historyError,
  } = useSettingHistory({ id: settingId, enabled: true })

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка параметра')}>
      <PageWrapper title={t('Карточка параметра')}>
        <WidgetWrapper>
          <SettingCard setting={setting} isLoading={isLoading} isError={isError} />
        </WidgetWrapper>
        <ToolbarWrapper>
          <Typography variant="h6">{t('История изменений')}</Typography>
        </ToolbarWrapper>
        <WidgetWrapper>
          <SettingHistory
            history={(historyData as any)?.logs ?? (historyData as any)?.history}
            isLoading={historyLoading}
            isError={historyError}
          />
        </WidgetWrapper>
      </PageWrapper>
    </Offcanvas>
  )
}
